import React, { Component } from "react";
import Header from "../layout/Header";
import BannerSimple from "../layout/BannerSimple";
import ContactInformation from "../layout/ContactInformation";
import Footer from "../layout/Footer";
import SEO from "../layout/SEO";
import Work from "../layout/Work";
import CurriculumVitae from "../layout/CurriculumVitae";

export default class Portfolio extends Component {
  componentDidMount() {
    window.resetScript();
  }

    render() {
        return (
            <>
                <SEO
                    title="Portfolio"
                    description="Découvrez mes projets, réalisations et compétences en développement web et création de contenu."
                    keywords="portfolio, projets, réalisations, compétences, développement web"
                />
                <Header active={ "Portfolio" } modeDark={ true } />

                <BannerSimple title = "Portfolio" boxElement = { [ { name: "Accueil", link: "/" }, { name: "Portfolio", link: "/portfolio" } ] } />

                <CurriculumVitae />

                <Work />

                <ContactInformation />

                <Footer />
            </>
        );
    }
}